import React, { useEffect, useState } from "react";
import cimg from "../../images/appointment.png";

import axios from "axios";
import { toast } from "react-toastify";

const getServices = async () => {
  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/service`);
  return res.data.data;
};

const Appointment = () => {
  const [serviceAndQuantity, setServiceAndQuantity] = useState([]);
  const [service, setService] = useState([]);
  const [serviceOption, setServiceOption] = useState([]);
  useEffect(() => {
    getServices().then((res) => {
      setServiceOption(res?.map((a) => [a.id, a.name]));
      setService(res);
    });
  }, []);
  const [forms, setForms] = useState({
    customerName: "",
    email: "",
    address: "",
    phone: "",
    serviceAndQunatity: [],
  });
  const submitHandler = async (e) => {
    e.preventDefault();
    if (serviceAndQuantity.length === 0) {
      toast.error("Please Select at least One Service", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/quotation-requests`,
      {
        customerName: forms.customerName,
        email: forms.email,
        address: forms.address,
        phone: Number(forms.phone),
        serviceAndQuantity: serviceAndQuantity,
      },
    );
    if (res.status === 201) {
      toast.success("Quotation Requested Successfully", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setForms({
        customerName: "",
        email: "",
        address: "",
        phone: "",
        serviceAndQunatity: [],
      });
      setServiceAndQuantity([]);
    } else {
      toast.error("Quotation Request Failed", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
  };

  return (
    <section className="wpo-contact-section section-padding">
      <div className="container">
        <div className="wpo-contact-section-wrapper">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-12">
              <div className="wpo-contact-form-area">
                <div className="wpo-section-title-s2">
                  <h2>Request An Quotation</h2>
                </div>
                <form
                  onSubmit={(e) => submitHandler(e)}
                  className="contact-validation-active"
                >
                  <div className="row">
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.customerName}
                          type="text"
                          required
                          name="customerName"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Your Name"
                        />
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.email}
                          type="email"
                          required
                          name="email"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Your Email"
                        />
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.phone}
                          type="phone"
                          name="phone"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Your phone"
                        />
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.address}
                          name="address"
                          required
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Address"
                        />
                      </div>
                    </div>
                    <div className="col col-lg-12 col-12">
                      <div className="form-field">
                        <select
                          className="form-control"
                          value={""}
                          onChange={(e) =>
                            setServiceAndQuantity([
                              ...serviceAndQuantity,
                              {
                                serviceId: Number(e.target.value),
                                quantity: 1,
                              },
                            ])
                          }
                          type="text"
                        >
                          <option value="">Choose a Service</option>
                          {serviceOption
                            ?.filter((service) => {
                              return !serviceAndQuantity.some(
                                (s) => s?.serviceId === service?.[0],
                              );
                            })
                            .map(([serviceValue, serviceLabel], i) => (
                              <option key={i} value={Number(serviceValue)}>
                                {serviceLabel}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div>
                        {serviceAndQuantity.map((item, index) => {
                          const serv = service?.find(
                            (service) => service.id === Number(item.serviceId),
                          );
                          return (
                            <div
                              key={index}
                              className=""
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                marginBottom: "4px",
                              }}
                            >
                              <div className="text-white">{serv?.name}</div>
                              <div className="form-field">
                                <input
                                  type="number"
                                  className=""
                                  style={{
                                    width: "50px",
                                    background: "transparent",
                                    border: "none",
                                    color: "white",
                                    borderBottom: "1px solid white",
                                    hover: "1px solid red",
                                  }}
                                  value={item.quantity}
                                  min={1}
                                  onChange={(e) =>
                                    setServiceAndQuantity(
                                      serviceAndQuantity.map((svc, i) =>
                                        i === index
                                          ? {
                                              ...svc,
                                              quantity: Number(e.target.value),
                                            }
                                          : svc,
                                      ),
                                    )
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                  fontSize: "20px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setServiceAndQuantity(
                                    serviceAndQuantity.filter(
                                      (_, i) => i !== index,
                                    ),
                                  )
                                }
                              >
                                X
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="submit-area">
                    <button type="submit" className="theme-btn">
                      <i
                        className="fa fa-angle-double-right"
                        aria-hidden="true"
                      ></i>{" "}
                      Submit Now
                    </button>
                  </div>
                </form>
                <div className="border-style"></div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="wpo-contact-img">
                <img src={cimg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Appointment;
